
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Engine } from '@/types';
import { cn } from '@/lib/utils';

interface EngineCardProps {
  engine: Engine;
  onClick?: (engine: Engine) => void;
  isSelected?: boolean;
}

export const EngineCard = ({ engine, onClick, isSelected }: EngineCardProps) => {
  const getStatusColor = (status: Engine['status']) => {
    switch (status) {
      case 'normal': return 'bg-green-500';
      case 'warning': return 'bg-yellow-500';
      case 'critical': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <Card 
      className={cn(
        'cursor-pointer transition-all duration-200 hover:shadow-lg',
        isSelected && 'ring-2 ring-blue-500'
      )}
      onClick={() => onClick?.(engine)}
    >
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">{engine.name}</CardTitle>
          <Badge 
            className={cn('text-white', getStatusColor(engine.status))}
            variant="secondary"
          >
            {engine.status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <span className="text-muted-foreground">温度:</span>
            <span className="ml-2 font-medium">{engine.temperature}°C</span>
          </div>
          <div>
            <span className="text-muted-foreground">转速:</span>
            <span className="ml-2 font-medium">{engine.rpm} RPM</span>
          </div>
          <div className="col-span-2">
            <span className="text-muted-foreground">油耗:</span>
            <span className="ml-2 font-medium">{engine.fuel_consumption} L/h</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
